import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { CYBER_CONFIG } from "../../constants";

interface UiPropsState {
  isAppLoading: boolean;
  useAppBackground: boolean;
  backgroundImageUrl?: string;
  showPdfReport: boolean;
  pdfReportFor?: string;
  pdfReportBy?: string;
}

const initialState: UiPropsState = {
  isAppLoading: false,
  useAppBackground: true,
  backgroundImageUrl: CYBER_CONFIG.backgroundImages.default,
  showPdfReport: false,
  pdfReportFor: undefined,
  pdfReportBy: undefined,
};

const uiPropsSlice = createSlice({
  name: "uiProps",
  initialState,
  reducers: {
    showAppLoader(state, action: PayloadAction<boolean>) {
      state.isAppLoading = action.payload;
    },
    setAppBackground(state, action: PayloadAction<boolean>) {
      state.useAppBackground = action.payload;
    },
    setBackgroundImageUrl(state, action: PayloadAction<string>) {
      state.backgroundImageUrl = action.payload;
    },
    setShowPdfReport(state, action: PayloadAction<boolean>) {
      state.showPdfReport = action.payload;
    },
    setPdfReportFor(state, action: PayloadAction<string | undefined>) {
      state.pdfReportFor = action.payload;
    },
    setPdfReportBy(state, action: PayloadAction<string | undefined>) {
      state.pdfReportBy = action.payload;
    },
  },
});

export const {
  showAppLoader,
  setAppBackground,
  setBackgroundImageUrl,
  setShowPdfReport,
  setPdfReportFor,
  setPdfReportBy,
} = uiPropsSlice.actions;


export default uiPropsSlice.reducer;

export type { UiPropsState };